import React, { useState, useEffect, useContext } from "react";
import { cmsApi } from "../../../../../Utils/API";
import { LANDING_PAGE_CMS_DATA } from "../../../../../Utils/GlobalConstants";
import CmsDetailsContext from "../../../../../Context/CmsDetails/CmsDetailsContext";
import synnexLogo from "../../../../../Assets/Images/Illustrations/Landing Page/Background-Image/png/synnex-cloud.png";
import styles from "./localNavbar.module.scss";

/**
 * LocalNavbar — self-contained navbar for the Admin Portal Credentials page.
 * - Fetches the same CMS background image used on the landing page (siteImages query).
 * - Falls back to the brand gradient if CMS is unavailable or still loading.
 * - Displays the Synnex logo on the left.
 * - No navigation links, no "Cloud Solution", "Become a Partner", or "Login" buttons.
 * - Always rendered regardless of authentication state.
 */
const LocalNavbar = () => {
  const globalData = useContext(CmsDetailsContext);
  const [backgroundImageData, setBackgroundImageData] = useState(null);
  const [imagePath, setImagePath] = useState("");
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  // Fetch background image from CMS (same query as UnautorisedNavbar / LandingPage)
  useEffect(() => {
    const data = `{
      siteImages {
        desktopImage { urls paths }
        mobileImage  { urls paths }
        tabletImage  { urls paths }
      }
    }`;

    const config = {
      headers: {
        "Content-Type": "application/graphql",
        Accept: "application/graphql",
      },
    };

    cmsApi
      .post(LANDING_PAGE_CMS_DATA, data, config)
      .then((resp) => {
        setBackgroundImageData(resp.data.data.siteImages[0]);
      })
      .catch(() => {
        // CMS unavailable — gradient fallback handled via CSS
      });
  }, []);

  // Resolve the correct image URL based on viewport width
  useEffect(() => {
    if (backgroundImageData && globalData) {
      if (windowWidth > 1400) {
        setImagePath(globalData.baseUrl + backgroundImageData.desktopImage.urls);
      } else if (windowWidth >= 768) {
        setImagePath(globalData.baseUrl + backgroundImageData.tabletImage.urls);
      } else {
        setImagePath(globalData.baseUrl + backgroundImageData.mobileImage.urls);
      }
    }
  }, [backgroundImageData, globalData, windowWidth]);

  // Track window resize
  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const bgStyle = imagePath
    ? {
        backgroundImage: `url(${imagePath})`,
        backgroundSize: "100% auto",
        backgroundPosition: "top",
        backgroundRepeat: "no-repeat",
      }
    : {};

  return (
    <div className={styles["navbar-wrapper"]} style={bgStyle}>
      <div className={styles["navbar-inner"]}>
        <img
          src={synnexLogo}
          alt="Synnex"
          className={styles["navbar-logo"]}
        />
      </div>
    </div>
  );
};

export default LocalNavbar;